import { render, staticRenderFns } from "./ConfirmAction.vue?vue&type=template&id=ff547602&"
import script from "./ConfirmAction.vue?vue&type=script&lang=js&"
export * from "./ConfirmAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports